import { Container, Section } from '@repo/ui'
import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const TermsPage = lazy(() =>
  import('@/features/legal/terms-page').then((mod) => ({ default: mod.TermsPage }))
)

const TermsSkeleton = () => (
  <Section variant="default" className="md:pt-24">
    <Container size="prose">
      <div className="space-y-6">
        <div className="h-10 w-2/3 animate-pulse rounded bg-muted" />
        <div className="space-y-3">
          <div className="h-4 w-full animate-pulse rounded bg-muted/80" />
          <div className="h-4 w-10/12 animate-pulse rounded bg-muted/70" />
          <div className="h-4 w-4/5 animate-pulse rounded bg-muted/60" />
        </div>
      </div>
    </Container>
  </Section>
)

export const Route = createFileRoute('/terms')({
  component: () => (
    <Suspense fallback={<TermsSkeleton />}>
      <TermsPage />
    </Suspense>
  ),
})
